import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-e', 'LetterE', [["path",{"d":"M17 4h-10v16h10","key":"svg-0"}],["path",{"d":"M7 12l8 0","key":"svg-1"}]]);